





















import { defineComponent, ref, PropType } from "@vue/composition-api";
interface Resource {
  url: string;
  name: string;
}
export default defineComponent({
  props: {
    title: {
      type: String as PropType<string>,
      default: ""
    },
    resources: {
      type: Array as PropType<Resource[]>,
      default: (): Resource[] => []
    }
  },
  setup(_, { emit }) {
    const url = ref<string>("");
    const name = ref<string>("");
    const remove = (name: string) => emit("remove", name);
    const add = () => {
      emit("add", { url: url.value, name: name.value });
      url.value = "";
      name.value = "";
    };
    return {
      url,
      name,
      remove,
      add
    };
  }
});
